import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';
import { LINE_ITEM_DAY, LINE_ITEM_NIGHT, propTypes } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { ensureListing, ensureUser } from '../../util/data';
import { richText } from '../../util/richText';
import { createSlug } from '../../util/urlHelpers';
import config from '../../config';
import { Avatar, NamedLink, ResponsiveImage } from '../../components';
import image1 from '../../assets/new-verified-logo.jpeg';
import { findOptionsForSelectFilter } from '../../util/search';
import css from './ListingCard.module.css';

import offeringPic from './images/Offer.jpg';
import lookingForPic from './images/Request.jpg';

const MIN_LENGTH_FOR_LONG_WORDS = 10;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: intl.formatMessage(
        { id: 'ListingCard.unsupportedPrice' },
        { currency: price.currency }
      ),
      priceTitle: intl.formatMessage(
        { id: 'ListingCard.unsupportedPriceTitle' },
        { currency: price.currency }
      ),
    };
  }
  return {};
};

class ListingImage extends Component {
  render() {
    return <ResponsiveImage {...this.props} />;
  }
}
const LazyImage = lazyLoadWithDimensions(ListingImage, { loadAfterInitialRendering: 3000 });

export const ListingCardComponent = props => {
  const { className, rootClassName, intl, listing, renderSizes, setActiveListing } = props;
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const id = currentListing.id.uuid;
  const { title = '', price } = currentListing.attributes;
  const slug = createSlug(title);
  const author = ensureUser(listing.author);
  const authorName = author.attributes.profile.displayName;
  const isVerified = author.attributes.profile.publicData?.isVerified;
  const { formattedPrice, priceTitle } = priceData(price, intl);
  const authorProfileImage =
    author.profileImage && author.profileImage.attributes.variants['landscape-crop2x']?.url;
  const unitType = config.bookingUnitType;
  const isNightly = unitType === LINE_ITEM_NIGHT;
  const isDaily = unitType === LINE_ITEM_DAY;

  const unitTranslationKey = isNightly
    ? 'ListingCard.perNight'
    : isDaily
      ? 'ListingCard.perDay'
      : 'ListingCard.perUnit';

  const subcategories = findOptionsForSelectFilter('subcategories', config.custom.filters);

  const isOffering = listing?.attributes.publicData?.category === 'offeringPlace';
  const placeholderImage = isOffering ? offeringPic : lookingForPic;
  const firstImage =
    currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

  return (
    <NamedLink className={classes} name="ListingPage" params={{ id, slug }}>
      <div
        className={css.threeToTwoWrapper}
        onMouseEnter={() => setActiveListing(currentListing.id)}
        onMouseLeave={() => setActiveListing(null)}
      >
        <div className={css.aspectWrapper}>
          {isOffering ? (
            <div className={css.badgeWrapper}>
              {/* <img src={badge} className={css.reviewsBadge} /> */}
              <center>
                <p className={css.reviewsBadge2}>Angebot</p>
              </center>
            </div>
          ) : (
            <div className={css.badgeWrapper}>
              {/* <img src={badge} className={css.reviewsBadge} /> */}
              <center>
                <p className={css.reviewsBadge2}>Gesuch</p>
              </center>
            </div>
          )}

          <LazyImage
            rootClassName={css.rootForImage}
            alt={title}
            image={firstImage}
            variants={['landscape-crop', 'landscape-crop2x']}
            sizes={renderSizes}
            placeholderImage={placeholderImage}
          />
        </div>
      </div>
      <div className={css.info}>
        {/* <div className={css.price}>
          <div className={css.priceValue} title={priceTitle}>
            {formattedPrice}
          </div>
          <div className={css.perUnit}>
            <FormattedMessage id={unitTranslationKey} />
          </div>
        </div> */}
        {/* {authorProfileImage ? ( */}
        {/* <img src={authorProfileImage} className={css.authorProfileImage} /> */}
        <div>

          <Avatar user={author} className={css.avatar} disableProfileLink />
        </div>

        {/* ) : null} */}
        <div className={css.mainInfo}>
          <div className={css.title}>
            {richText(title, {
              longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
              longWordClass: css.longWord,
            })}
          </div>
          <div className={css.authorInfo}>
            <FormattedMessage id="ListingCard.hostedBy" values={{ authorName }} />
            &nbsp;&nbsp;
            {isVerified ? <img src={image1} alt="verified" width={65} height={20} /> : null}
          </div>
        </div>
      </div>
    </NamedLink>
  );
};

ListingCardComponent.defaultProps = {
  className: null,
  rootClassName: null,
  renderSizes: null,
  setActiveListing: () => null,
};

ListingCardComponent.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
  listing: propTypes.listing.isRequired,

  // Responsive image sizes hint
  renderSizes: string,

  setActiveListing: func,
};

export default injectIntl(ListingCardComponent);
